import iban from 'iban'
import { isValidPhoneNumber } from 'libphonenumber-js'
import isDecimal from 'validator/lib/isDecimal'
import isInt from 'validator/lib/isInt'
import isMobilePhone from 'validator/lib/isMobilePhone'
import isNumeric from 'validator/lib/isNumeric'

import {
  isCartaId,
  isCartaIdElettr,
  isPassaporto,
  isPatente,
  isPatenteElettr,
  isPortoDarmi,
  isTesseraMinisteriale,
} from '../../utils/findomesticUtils'

// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

const consonants = function (str) {
  return str.replace(/[^BCDFGHJKLMNPQRSTVWXYZ]/gi, '')
}

const vowels = function (str) {
  return str.replace(/[^AEIOU]/gi, '')
}

const validateEmail = function (str) {
  const mailRegexp =
    // eslint-disable-next-line
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return mailRegexp.test(str)
}

const cognomeCode = function (cognome) {
  let code = consonants(cognome)
  code += vowels(cognome)
  code += 'XXX'
  return code.substr(0, 3).toUpperCase()
}

const nomeCode = function (nome) {
  let code = consonants(nome)
  if (code.length >= 4) {
    code = code.charAt(0) + code.charAt(2) + code.charAt(3)
  } else {
    code += vowels(nome)
    code += 'XXX'
    code = code.substr(0, 3)
  }
  return code.toUpperCase()
}

const annoCode = function (anno) {
  const code = anno.toString()
  return code.substr(code.length - 2, 2)
}

const meseCode = function (mese) {
  const meseCodes = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T']
  return meseCodes[parseInt(mese, 10) - 1]
}

const giornoCode = function (giorno, sesso) {
  let code = parseInt(giorno, 10)
  code = sesso.toUpperCase() === 'M' ? code : code + 40
  code = `0${code.toString()}`
  code = code.slice(-2)
  return code
}

const codiceFiscaleValidation = function (cf, against) {
  let _cf = cf
  if (_cf === '') {
    return false
  }

  _cf = _cf.toUpperCase()

  if (_cf.length !== 16) {
    // La lunghezza del codice fiscale non è corretta: il codice fiscale dovrebbe essere lungo esattamente 16 caratteri
    return false
  }

  const validi = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

  for (let i = 0; i < 16; i++) {
    if (validi.indexOf(_cf.charAt(i)) === -1) {
      // Il codice fiscale contiene un carattere non valido _cf.charAt(i) I caratteri validi sono le lettere e le cifre
      return false
    }
  }

  if (
    against.cognome.length > 0 &&
    cognomeCode(against.cognome) !== _cf.substr(0, 3)
  ) {
    return false
  }

  if (against.nome.length > 0 && nomeCode(against.nome) !== _cf.substr(3, 3)) {
    return false
  }

  if (
    'year' in against.data_di_nascita &&
    annoCode(against.data_di_nascita.year) !== _cf.substr(6, 2)
  ) {
    return false
  }

  if (
    'month' in against.data_di_nascita &&
    meseCode(against.data_di_nascita.month) !== _cf.substr(8, 1)
  ) {
    return false
  }

  if (
    'day' in against.data_di_nascita &&
    against.sesso.length > 0 &&
    giornoCode(against.data_di_nascita.day, against.sesso) !== _cf.substr(9, 2)
  ) {
    return false
  }

  if (against.paese_comune_di_nascita.length > 0) {
    let landRegister = against.paese_comune_di_nascita.split('|')
    landRegister = landRegister[landRegister.length - 1]
    if (landRegister !== _cf.substr(11, 4)) {
      return false
    }
  }

  const set1 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const set2 = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const setpari = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const setdisp = 'BAKPLCQDREVOSFTGUHMINJWZYX'
  let s = 0

  for (let i = 1; i <= 13; i += 2) {
    s += setpari.indexOf(set2.charAt(set1.indexOf(_cf.charAt(i))))
  }

  for (let i = 0; i <= 14; i += 2) {
    s += setdisp.indexOf(set2.charAt(set1.indexOf(_cf.charAt(i))))
  }

  if (s % 26 !== _cf.charCodeAt(15) - 'A'.charCodeAt(0)) {
    // Il codice fiscale non è corretto: il codice di controllo non corrisponde
    return false
  }

  return true
}

const dateValidationClienti = function (value, type = 'full') {
  let re = new RegExp(
    // eslint-disable-next-line
    /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-](\d{4})$/
  )

  if (type !== 'full') {
    // eslint-disable-next-line
    re = new RegExp(/^(0?[1-9]|1[012])[\/\-](\d{4})$/)
  }

  const isValid = re.test(value)
  const result = {}

  result.raw = value

  if (isValid) {
    const processed = re.exec(value)

    result.year = processed[type === 'full' ? 3 : 2]
    result.month = `0${processed[type === 'full' ? 2 : 1]}`.slice(-2)

    if (type !== 'full') {
      const lastDayOfMonth = new Date(
        result.year,
        parseInt(result.month, 10),
        0
      )

      result.day = `0${lastDayOfMonth.getDate()}`.slice(-2)
    } else {
      result.day = `0${processed[1]}`.slice(-2)
    }
  }

  return {
    isValid,
    value: result,
  }
}

/* comes from here: http://www.icosaedro.it/cf-pi/vedi-codice.cgi?f=pi-js.txt */

const validatePartitaIva = function (pi) {
  if (!/^[0-9]{11}$/.test(pi)) {
    return false
  }

  let s = 0

  for (let i = 0; i <= 9; i += 2) {
    s += pi.charCodeAt(i) - '0'.charCodeAt(0)
  }

  for (let i = 1; i <= 9; i += 2) {
    let c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0))
    if (c > 9) {
      c -= 9
    }
    s += c
  }

  const atteso = (10 - (s % 10)) % 10

  if (atteso !== pi.charCodeAt(10) - '0'.charCodeAt(0)) {
    return false
  }

  return true
}

const isValidNameLikeString = value => !RegExp('[<>&]').test(value)

const verify = function (label, value, against = null) {
  let isRequired = false
  let isValid = false
  let re
  let dvc
  let updates = { stores: {}, states: {} }
  let _value = value

  if (typeof _value === 'string') {
    _value = `${_value}`
    _value = _value.trim()
  }

  switch (label) {
    case 'name':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired
      break
    case 'surname':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired
      break
    case 'dati_cliente_ragione_sociale':
      const isEmpty = value.length === 0
      const isMoreThanOne = value.length > 1
      isValid = isEmpty || (isMoreThanOne && isValidNameLikeString(_value))
      if (isValid) {
        _value = _value.capitalize()
      }
      break
    case 'email':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && validateEmail(_value || '')
      if (isValid) {
        _value = _value.toLowerCase()
      }
      break
    case 'bonifico_email':
      isValid = !_value || _value.length === 0 || validateEmail(_value || '')
      if (isValid) {
        _value = _value.toLowerCase()
      }
      break
    case 'dati_cliente_email':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && validateEmail(_value || '')
      if (isValid) {
        _value = _value.toLowerCase()
      }
      break
    case 'dati_findomestic_numero_documento_retro_patente':
      re = new RegExp(/[a-zA-Z]{2}[0-9]{7}/)
      isValid = _value.length > 0 ? re.test(_value) : true
      break
    case 'phone':
      isRequired = !_value || _value.length === 0
      isValid = _value.length > 0 ? isMobilePhone(_value) : false
      break

    case 'dati_compass_telefono_fisso_lavoro':
    case 'dati_findomestic_telefono_fisso_lavoro':
    case 'dati_compass_telefono_fisso_personale':
      isValid = !_value.length || isValidPhoneNumber(_value)
      break
    case 'dati_cliente_phone':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && isMobilePhone(_value)
      break
    case 'consenso_obbligatorio_privacy_brumbrum':
      isRequired = !_value
      isValid = _value
      break
    case 'newsletter':
      isValid = true
      break
    case 'presecci_nome':
    case 'presecci_cognome':
    case 'dati_cliente_nome':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired
      break
    case 'dati_cliente_cognome':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired
      break
    case 'dati_nlt_carica_pubblica':
    case 'dati_nlt_altre_fonti_reddito':
    case 'dati_nlt_professione':
    case 'dati_findomestic_carica_pubblica':
    case 'dati_findomestic_altre_fonti_reddito':
    case 'dati_findomestic_professione':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]{2,}/)
      isValid = !isRequired && re.test(_value) && isValidNameLikeString(_value)
      if (isValid) {
        _value = _value.capitalize()
      }
      break
    case 'dati_nlt_data_termine_contratto':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value, 'full')
      isValid = dvc.isValid
      if (isValid) {
        _value = dvc.value
      } else {
        _value = { raw: value }
      }

      break
    case 'presecci_comune_nascita':
    case 'dati_cliente_comune_nascita':
    case 'dati_compass_stato_civile':
    case 'dati_cliente_documento':
    case 'dati_cliente_ente_rilascio_documento':
    case 'dati_cliente_cittadinanza':
    case 'dati_compass_situazione_abitativa':
    case 'dati_cliente_indirizzo_residenza':
    case 'dati_cliente_indirizzo_consegna':
    case 'dati_cliente_indirizzo_fatturazione':
    case 'dati_compass_indirizzo_precedente':
    case 'dati_findomestic_indirizzo_precedente':
    case 'dati_cliente_indirizzo_domicilio':
    case 'dati_compass_tipo_attivita':
    case 'dati_compass_settore':
    case 'dati_compass_occupazione':
    case 'dati_compass_datore_lavoro':
    case 'dati_findomestic_datore_lavoro':
    case 'dati_compass_indirizzo_lavoro':
    case 'dati_findomestic_indirizzo_lavoro':
    case 'dati_compass_tipo_conto_corrente':
    case 'dati_nlt_stato_civile':
    case 'dati_nlt_situazione_lavorativa':
    case 'dati_nlt_dettaglio_ruolo_pa':
    case 'dati_nlt_situazione_abitativa':
    case 'dati_nlt_occupazione':
    case 'dati_nlt_tipo_contratto':
    case 'dati_nlt_nome_societa':
    case 'dati_nlt_carica_privata':
    case 'dati_nlt_settore':
    case 'dati_findomestic_stato_civile':
    case 'dati_findomestic_situazione_lavorativa':
    case 'dati_findomestic_coniuge_situazione_lavorativa':
    case 'dati_findomestic_situazione_abitativa':
    case 'dati_findomestic_occupazione':
    case 'dati_findomestic_coniuge_occupazione':
    case 'dati_findomestic_tipo_contratto':
    case 'dati_findomestic_nome_societa':
    case 'dati_findomestic_carica_privata':
    case 'dati_findomestic_settore':
    case 'dati_findomestic_coniuge_settore':
    case 'dati_findomestic_paese_di_attivita_principale':
    case 'dati_nlt_relazione_intestatario_iban':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]{2,}/)
      isValid = !isRequired && re.test(_value)
      break
    case 'dati_findomestic_settore_rischio_aml':
    case 'dati_findomestic_coniuge_settore_rischio_aml':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\d]{1,}/)
      isValid = !isRequired && re.test(_value)
      break
    case 'dati_cliente_citta_residenza':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]{2,}/)
      isValid = !isRequired && re.test(_value)
      if (isValid) {
        const splitted = _value.split('|')
        if (splitted.length >= 6) {
          splitted.splice(0, 4)
          if (splitted.length === 2) {
            updates = {
              states: {
                select_cap_residenza: false,
                caps_residenza: [],
                cap_residenza: splitted[0],
              },
              stores: {
                select_cap_residenza: false,
                caps_residenza: [],
                cap_residenza: splitted[0],
              },
            }
          } else {
            splitted.splice(splitted.length - 1, 1)
            splitted.sort()
            const cap = splitted.map(o => ({ label: o, value: o }))
            if (
              'dati_cliente_caps_residenza' in against &&
              !against.dati_cliente_caps_residenza.length === cap.length
            ) {
              updates = {
                states: {
                  select_cap_residenza: true,
                  caps_residenza: cap,
                  cap_residenza: '',
                },
                stores: {
                  select_cap_residenza: true,
                  caps_residenza: cap,
                  cap_residenza: '',
                },
              }
            } else {
              updates = {
                states: {
                  select_cap_residenza: true,
                  caps_residenza: cap,
                },
                stores: {
                  select_cap_residenza: true,
                  caps_residenza: cap,
                },
              }
            }
          }
        }
      }
      break
    case 'dati_cliente_numero_documento':
      isRequired = !_value || _value.length === 0
      switch (true) {
        case against.dati_cliente_documento === 'CI':
        case isCartaIdElettr(against.dati_cliente_documento):
        case isCartaId(against.dati_cliente_documento):
          re = new RegExp(/^[A-Za-z]{2}[0-9]{7}$/)
          isValid = !isRequired && re.test(_value)
          if (!isValid) {
            re = new RegExp(/^[A-Za-z]{2}[0-9]{5}[A-Za-z]{2}$/)
            isValid = !isRequired && re.test(_value)
          }
          if (!isValid) {
            re = new RegExp(/^[0-9]{7}[A-Za-z]{2}$/)
            isValid = !isRequired && re.test(_value)
          }
          break
        case against.dati_cliente_documento === 'Passaporto':
        case isPassaporto(against.dati_cliente_documento):
          re = new RegExp(/^(\b(?:([A-Za-z0-9])(?!\2{5})){5,14}\b)$/)
          isValid = !isRequired && re.test(_value)
          break
        case against.dati_cliente_documento === 'Patente':
        case isPatente(against.dati_cliente_documento):
        case isPatenteElettr(against.dati_cliente_documento):
          re = new RegExp(/^[a-zA-Z0-9]{5,14}$/)
          isValid = !isRequired && re.test(_value)
          break
        case isPortoDarmi(against.dati_cliente_documento):
        case isTesseraMinisteriale(against.dati_cliente_documento):
          const __isEmpty = value.length === 0
          const __isMoreThanOne = value.length > 1
          isValid = __isEmpty ? true : __isMoreThanOne
          if (isValid) {
            _value = _value.capitalize()
          }
          break
        default:
          isValid = false
          break
      }
      if (isValid) {
        _value = _value.toUpperCase()
      }
      break
    case 'dati_cliente_citta_domicilio':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]{2,}/)
      isValid = !isRequired && re.test(_value)
      if (isValid) {
        const splitted = _value.split('|')
        if (splitted.length >= 6) {
          splitted.splice(0, 4)
          if (splitted.length === 2) {
            updates = {
              states: {
                select_cap_domicilio: false,
                caps_domicilio: [],
                cap_domicilio: splitted[0],
              },
              stores: {
                select_cap_domicilio: false,
                caps_domicilio: [],
                cap_domicilio: splitted[0],
              },
            }
          } else {
            splitted.splice(splitted.length - 1, 1)
            splitted.sort()
            const cap = splitted.map(o => ({ label: o, value: o }))
            if (
              'dati_cliente_caps_domicilio' in against &&
              !against.dati_cliente_caps_domicilio.length === cap.length
            ) {
              updates = {
                states: {
                  select_cap_domicilio: true,
                  caps_domicilio: cap,
                  cap_domicilio: '',
                },
                stores: {
                  select_cap_domicilio: true,
                  caps_domicilio: cap,
                  cap_domicilio: '',
                },
              }
            } else {
              updates = {
                states: {
                  select_cap_domicilio: true,
                  caps_domicilio: cap,
                },
                stores: {
                  select_cap_domicilio: true,
                  caps_domicilio: cap,
                },
              }
            }
          }
        }
      }
      break

    case 'dati_cliente_citta_consegna':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]{2,}/)
      isValid = !isRequired && re.test(_value)
      if (isValid) {
        const splitted = _value.split('|')
        if (splitted.length >= 6) {
          splitted.splice(0, 4)
          if (splitted.length === 2) {
            updates = {
              states: {
                select_cap_consegna: false,
                caps_consegna: [],
                cap_consegna: splitted[0],
              },
              stores: {
                select_cap_consegna: false,
                caps_consegna: [],
                cap_consegna: splitted[0],
              },
            }
          } else {
            splitted.splice(splitted.length - 1, 1)
            splitted.sort()
            const cap = splitted.map(o => ({ label: o, value: o }))
            if (
              'dati_cliente_caps_consegna' in against &&
              !against.dati_cliente_caps_consegna.length === cap.length
            ) {
              updates = {
                states: {
                  select_cap_consegna: true,
                  caps_consegna: cap,
                  cap_consegna: '',
                },
                stores: {
                  select_cap_consegna: true,
                  caps_consegna: cap,
                  cap_consegna: '',
                },
              }
            } else {
              updates = {
                states: {
                  select_cap_consegna: true,
                  caps_consegna: cap,
                },
                stores: {
                  select_cap_consegna: true,
                  caps_consegna: cap,
                },
              }
            }
          }
        }
      }
      break
    case 'dati_cliente_citta_fatturazione':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]{2,}/)
      isValid = !isRequired && re.test(_value)
      if (isValid) {
        const splitted = _value.split('|')
        if (splitted.length >= 6) {
          splitted.splice(0, 4)
          if (splitted.length === 2) {
            updates = {
              states: {
                select_cap_fatturazione: false,
                caps_fatturazione: [],
                cap_fatturazione: splitted[0],
              },
              stores: {
                select_cap_fatturazione: false,
                caps_fatturazione: [],
                cap_fatturazione: splitted[0],
              },
            }
          } else {
            splitted.splice(splitted.length - 1, 1)
            splitted.sort()
            const cap = splitted.map(o => ({ label: o, value: o }))
            if (
              'dati_cliente_caps_fatturazione' in against &&
              !against.dati_cliente_caps_fatturazione.length === cap.length
            ) {
              updates = {
                states: {
                  select_cap_fatturazione: true,
                  caps_fatturazione: cap,
                  cap_fatturazione: '',
                },
                stores: {
                  select_cap_fatturazione: true,
                  caps_fatturazione: cap,
                  cap_fatturazione: '',
                },
              }
            } else {
              updates = {
                states: {
                  select_cap_fatturazione: true,
                  caps_fatturazione: cap,
                },
                stores: {
                  select_cap_fatturazione: true,
                  caps_fatturazione: cap,
                },
              }
            }
          }
        }
      }
      break
    case 'dati_compass_comune_precedente':
    case 'dati_findomestic_comune_precedente':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]{2,}/)
      isValid = !isRequired && re.test(_value)
      if (isValid) {
        const splitted = _value.split('|')
        if (splitted.length >= 6) {
          splitted.splice(0, 4)
          if (splitted.length === 2) {
            updates = {
              states: {
                select_cap_precedente: false,
                caps_precedente: [],
                cap_precedente: splitted[0],
              },
              stores: {
                select_cap_precedente: false,
                caps_precedente: [],
                cap_precedente: splitted[0],
              },
            }
          } else {
            splitted.splice(splitted.length - 1, 1)
            splitted.sort()
            const cap = splitted.map(o => ({ label: o, value: o }))
            if (
              'dati_cliente_caps_precedente' in against &&
              !against.dati_cliente_caps_precedente.length === cap.length
            ) {
              updates = {
                states: {
                  select_cap_precedente: true,
                  caps_precedente: cap,
                  cap_precedente: '',
                },
                stores: {
                  select_cap_precedente: true,
                  caps_precedente: cap,
                  cap_precedente: '',
                },
              }
            } else {
              updates = {
                states: {
                  select_cap_precedente: true,
                  caps_precedente: cap,
                },
                stores: {
                  select_cap_precedente: true,
                  caps_precedente: cap,
                },
              }
            }
          }
        }
      }
      break
    case 'dati_compass_comune_lavoro':
    case 'dati_findomestic_comune_lavoro':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]{2,}/)
      isValid = !isRequired && re.test(_value)
      if (isValid) {
        const splitted = _value.split('|')
        if (splitted.length >= 6) {
          splitted.splice(0, 4)
          if (splitted.length === 2) {
            updates = {
              states: {
                select_cap_lavoro: false,
                caps_lavoro: [],
                cap_lavoro: splitted[0],
              },
              stores: {
                select_cap_lavoro: false,
                caps_lavoro: [],
                cap_lavoro: splitted[0],
              },
            }
          } else {
            splitted.splice(splitted.length - 1, 1)
            splitted.sort()
            const cap = splitted.map(o => ({ label: o, value: o }))
            if (
              'dati_cliente_caps_lavoro' in against &&
              !against.dati_cliente_caps_lavoro.length === cap.length
            ) {
              updates = {
                states: {
                  select_cap_lavoro: true,
                  caps_lavoro: cap,
                  cap_lavoro: '',
                },
                stores: {
                  select_cap_lavoro: true,
                  caps_lavoro: cap,
                  cap_lavoro: '',
                },
              }
            } else {
              updates = {
                states: {
                  select_cap_lavoro: true,
                  caps_lavoro: cap,
                },
                stores: {
                  select_cap_lavoro: true,
                  caps_lavoro: cap,
                },
              }
            }
          }
        }
      }
      break
    case 'dati_cliente_sesso':
    case 'presecci_sesso':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && (_value === 'M' || _value === 'F')
      break
    case 'dati_cliente_tipo_permesso_soggiorno':
      isRequired = !_value || _value.length === 0
      isValid =
        !isRequired && (_value === 'unlimited' || _value === 'temporary')
      break
    case 'presecci_codice_fiscale':
    case 'dati_cliente_codice_fiscale':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && codiceFiscaleValidation(_value, against)
      if (isValid) {
        _value = _value.toUpperCase()
      }
      break
    case 'dati_cliente_partita_iva':
      isValid = _value.length === 0 || validatePartitaIva(_value)
      if (isValid) {
        _value = _value.toUpperCase()
      }
      break
    case 'dati_cliente_data_di_nascita':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value)
      isValid = dvc.isValid
      if (isValid) {
        const { year } = dvc.value
        const month = parseInt(dvc.value.month, 10) - 1
        const { day } = dvc.value
        const diff =
          (new Date() - new Date(year, month, day)) /
          1000 /
          60 /
          60 /
          24 /
          365.25
        isValid = diff >= 18
        if (isValid) {
          _value = dvc.value
        } else {
          _value = { raw: value }
        }
      } else {
        _value = { raw: value }
      }
      break
    case 'presecci_data_di_nascita':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value)
      isValid = dvc.isValid
      if (isValid) {
        const { year } = dvc.value
        const month = parseInt(dvc.value.month, 10) - 1
        const { day } = dvc.value
        const diff =
          (new Date() - new Date(year, month, day)) /
          1000 /
          60 /
          60 /
          24 /
          365.25
        isValid = diff >= 18 && diff < 71
        if (isValid) {
          _value = dvc.value
        } else {
          _value = { raw: value }
        }
      } else {
        _value = { raw: value }
      }
      break
    case 'dati_cliente_data_di_nascita_nlt':
    case 'dati_cliente_data_di_nascita_findomestic':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value)
      isValid = dvc.isValid
      if (isValid) {
        const { year } = dvc.value
        const month = parseInt(dvc.value.month, 10) - 1
        const { day } = dvc.value
        const diff =
          (new Date() - new Date(year, month, day)) /
          1000 /
          60 /
          60 /
          24 /
          365.25
        isValid = diff >= 18 && diff < 75
        if (isValid) {
          _value = dvc.value
        } else {
          _value = { raw: value }
        }
      } else {
        _value = { raw: value }
      }
      break
    case 'dati_compass_politicamente_esposto':
    case 'dati_findomestic_politicamente_esposto':
    case 'dati_nlt_altre_fonti_switch':
    case 'dati_nlt_carica_pubblica_switch':
    case 'dati_findomestic_altre_fonti_switch':
    case 'dati_findomestic_carica_pubblica_switch':
      _value = _value.toString()
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && (_value === '0' || _value === '1')
      break
    case 'dati_cliente_data_rilascio_documento':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value)
      isValid = dvc.isValid
      if (isValid) {
        const compare = against.dati_cliente_data_di_nascita
        const { year } = dvc.value
        const month = parseInt(dvc.value.month, 10) - 1
        const { day } = dvc.value
        const compareMonth = parseInt(compare.month, 10) - 1
        const diffVsCompare =
          new Date(year, month, day) -
          new Date(compare.year, compareMonth, compare.day)
        const diff = diffVsCompare / 1000 / 60 / 60 / 24
        const diff2 =
          (new Date() - new Date(year, month, day)) / 1000 / 60 / 60 / 24
        isValid = diff >= 0 && diff2 >= 0
        if (isValid) {
          _value = dvc.value
        } else {
          _value = { raw: value }
        }
      } else {
        _value = { raw: value }
      }
      break
    case 'dati_cliente_cap_residenza':
    case 'dati_cliente_cap_fatturazione':
    case 'dati_compass_cap_precedente':
    case 'dati_findomestic_cap_precedente':
    case 'dati_cliente_cap_domicilio':
    case 'dati_cliente_cap_consegna':
    case 'dati_compass_cap_lavoro':
    case 'dati_findomestic_cap_lavoro':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\d]{5}/)
      isValid = !isRequired && re.test(_value)
      break
    case 'dati_cliente_numero_civico_residenza':
    case 'dati_cliente_numero_civico_consegna':
    case 'dati_cliente_numero_civico_fatturazione':
    case 'dati_findomestic_civico_precedente':
    case 'dati_cliente_civico_domicilio':
    case 'dati_findomestic_civico_lavoro':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/\b\d{1,7}(?:[A-z])?(?:\/[A-z])?\b/)
      isValid = !isRequired && re.test(_value)
      break
    case 'dati_compass_civico_precedente':
    case 'dati_compass_civico_domicilio':
    case 'dati_compass_civico_lavoro':
    case 'dati_nlt_anzianita':
    case 'dati_nlt_anni_apertura_conto':
    case 'dati_findomestic_anzianita':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && !Number.isNaN(parseInt(_value, 10))
      if (isValid) {
        _value = parseInt(_value, 10)
      }
      break
    case 'dati_findomestic_coniuge_data_scadenza_contratto':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value, 'short')
      isValid = dvc.isValid
      if (isValid) {
        const diff =
          (new Date(dvc.value.year, dvc.value.month, dvc.value.day) -
            new Date()) /
          1000 /
          60 /
          60 /
          24
        if (diff <= 0) {
          isValid = false
        }
      }
      _value = dvc.value
      break
    case 'dati_compass_residente_dal':
    case 'dati_findomestic_residente_dal':
    case 'dati_compass_data_apertura_conto':
    case 'dati_findomestic_data_apertura_conto':
    case 'dati_compass_data_inizio_attivita':
    case 'dati_findomestic_data_inizio_attivita':
    case 'dati_findomestic_coniuge_data_inizio_attivita':
    case 'dati_cliente_data_rilascio_permesso_soggiorno':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value, 'short')
      isValid = dvc.isValid
      if (isValid) {
        const compare = against.dati_cliente_data_di_nascita
        const { year } = dvc.value
        const month = parseInt(dvc.value.month, 10) - 1
        const { day } = dvc.value
        const compareMonth = parseInt(compare.month, 10) - 1
        const diffVsCompare =
          new Date(year, month, day) -
          new Date(compare.year, compareMonth, compare.day)
        const diff = diffVsCompare / 1000 / 60 / 60 / 24
        const diff2 =
          (new Date() - new Date(year, month, day)) / 1000 / 60 / 60 / 24
        isValid = diff >= 0 && diff2 >= 0
        if (isValid) {
          _value = dvc.value
        } else {
          _value = { raw: value }
        }
      } else {
        _value = { raw: value }
      }
      break
    case 'dati_compass_reddito':
    case 'dati_nlt_reddito_mensile':
    case 'dati_findomestic_costo_abitazione':
    case 'dati_nlt_reddito_coniuge':
    case 'dati_findomestic_coniuge_reddito_mensile_lavoro':
    case 'dati_findomestic_reddito_mensile_lavoro':
      isRequired = !_value || _value === 0
      isValid =
        !isRequired &&
        isNumeric(_value.toString() || '') &&
        parseInt(_value, 10) >= 0
      _value = parseInt(_value, 10)
      break
    case 'dati_compass_privacy_obbligatoria_1':
    case 'dati_compass_privacy_obbligatoria_1_mag2018':
    case 'dati_compass_presa_visione_obbligatoria':
    case 'dati_compass_condizioni_brumbrum_obbligatorie':
    case 'dati_cliente_condizioni_brumbrum_obbligatorie':
    case 'dati_findomestic_condizioni_brumbrum_obbligatorie':
    case 'dati_cliente_informativa_trattamento_dati_personali_garanzia':
    case 'dati_nlt_consenso_base_privacy_arval':
    case 'dati_nlt_autocertificazione_1':
    case 'dati_nlt_autocertificazione_2':
    case 'dati_nlt_presa_visione_condizioni_brumbrum':
    case 'dati_nlt_consenso_base_privacy_brumbrum':
      isRequired = !_value || _value.length === 0
      _value = _value === true || _value === '1' || _value === 1 ? '1' : '0'
      isValid =
        !isRequired && (_value === '1' || _value === true || _value === 1)
      break
    case 'dati_compass_privacy_facoltativa_1':
    case 'dati_compass_privacy_facoltativa_2':
    case 'dati_compass_privacy_facoltativa_3':
      isRequired = false
      _value = _value === true || _value === '1' || _value === 1 ? '1' : '0'
      isValid = !isRequired
      break
    case 'dati_cliente_domicilio_diverso':
    case 'dati_cliente_fatturazione_uguale':
      isRequired = !_value || _value.length === 0
      _value = _value === true || _value === '1' || _value === 1 ? '1' : '0'
      isValid = !isRequired
      break
    case 'dati_findomestic_flagQualita':
    case 'dati_findomestic_flagSocietaTerze':
    case 'dati_findomestic_flagPromozioni':
      isValid = true
      _value = _value === true || _value === '1' || _value === 1 ? '1' : '0'
      break
    case 'dati_compass_membri_familiari':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]+/)
      isValid = !isRequired && re.test(_value)
      break
    // eslint-disable-next-line no-case-declarations
    case 'dati_compass_familiari_con_reddito':
      isRequired = !_value || _value.length === 0
      re = new RegExp(/[\w\s]+/)
      const membri = against.dati_compass_membri_familiari
      const familiari = parseInt(
        membri === '3+' ? '4' : against.dati_compass_membri_familiari,
        10
      )
      const familiariConReddito = parseInt(_value === '3+' ? '4' : _value, 10)
      isValid =
        !isRequired && re.test(_value) && familiariConReddito <= familiari
      break
    case 'dati_compass_altre_carte':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && _value.length > 0
      break
    case 'dati_nlt_stripe_payment_method':
      isRequired = !_value
      isValid = !isRequired && _value.status
      break
    case 'dati_compass_iban':
    case 'dati_nlt_iban':
    case 'dati_findomestic_iban':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && iban.isValid(_value)
      if (isValid) {
        _value = _value.toUpperCase().replace(/\s/g, '')
      }
      break
    case 'custom_calc_quota_da_finanziare':
      isRequired = !_value || _value.length === 0
      isValid = !isRequired && isDecimal(_value.toString() || '')
      if (isValid) {
        _value = parseInt(_value, 10)
        const valoreSupImportMin = _value >= against.importo_minimo_finanziabile
        const valoreInfImportMax =
          _value <= against.importo_massimo_finanziabile
        isValid = valoreSupImportMin && valoreInfImportMax
      }
      break
    case 'custom_calc_rata_mensile_desiderata':
      isRequired = !_value || _value.length === 0
      isValid =
        !isRequired && isInt(_value.toString() || '', { min: 50, max: 1500 })
      if (isValid) {
        _value = parseInt(_value, 10)
      }
      break
    case 'dati_cliente_data_scadenza_permesso_soggiorno':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value)
      isValid = dvc.isValid
      if (isValid) {
        const month = parseInt(dvc.value.month, 10) - 1
        const diff =
          (new Date(dvc.value.year, month, dvc.value.day) - new Date()) /
          1000 /
          60 /
          60 /
          24
        isValid = diff > 0
        if (isValid) {
          _value = dvc.value
        } else {
          _value = { raw: value }
        }
      } else {
        _value = { raw: value }
      }
      break
    case 'dati_findomestic_data_scadenza_contratto':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value, 'short')
      isValid = dvc.isValid
      if (isValid) {
        const month = parseInt(dvc.value.month, 10) - 1
        const diff =
          (new Date(dvc.value.year, month, dvc.value.day) - new Date()) /
          1000 /
          60 /
          60 /
          24
        let diff2 = (new Date() - new Date()) / 1000 / 60 / 60 / 24
        let months = false
        for (let i = 0; i < against.dati_finanziamento.length; i++) {
          const idFinanziamento = parseInt(
            against.dati_finanziamento[i].id_finanziamento,
            10
          )
          if (
            idFinanziamento ===
            parseInt(against.dati_ordine_id_finanziamento, 10)
          ) {
            months = against.dati_finanziamento[i].durata_contratto
            break
          }
        }
        if (months) {
          const endDate = new Date()
          endDate.setMonth(endDate.getMonth() + months)
          const month2 = parseInt(dvc.value.month, 10) - 1
          diff2 =
            (new Date(dvc.value.year, month2, dvc.value.day) - endDate) /
            1000 /
            60 /
            60 /
            24
        }
        isValid = diff > 0 && diff2 >= 0
        if (isValid) {
          _value = dvc.value
        } else {
          _value = { raw: value }
        }
      } else {
        _value = { raw: value }
      }
      break
    case 'dati_compass_data_scadenza_contratto':
      isRequired = !_value || _value.length === 0
      dvc = dateValidationClienti(_value)
      isValid = dvc.isValid
      if (isValid) {
        const month = parseInt(dvc.value.month, 10) - 1
        const diff =
          (new Date(dvc.value.year, month, dvc.value.day) - new Date()) /
          1000 /
          60 /
          60 /
          24
        let diff2 = (new Date() - new Date()) / 1000 / 60 / 60 / 24
        let months = false
        for (let i = 0; i < against.dati_finanziamento.length; i++) {
          const idFinanziamento = parseInt(
            against.dati_finanziamento[i].id_finanziamento,
            10
          )
          if (
            idFinanziamento ===
            parseInt(against.dati_ordine_id_finanziamento, 10)
          ) {
            months = against.dati_finanziamento[i].durata_contratto
            break
          }
        }
        if (months) {
          const endDate = new Date()
          endDate.setMonth(endDate.getMonth() + months)
          const month2 = parseInt(dvc.value.month, 10) - 1
          diff2 =
            (new Date(dvc.value.year, month2, dvc.value.day) - endDate) /
            1000 /
            60 /
            60 /
            24
        }
        isValid = diff > 0 && diff2 >= 0
        if (isValid) {
          _value = dvc.value
        } else {
          _value = { raw: value }
        }
      } else {
        _value = { raw: value }
      }
      break
    case 'bonifico_cro_trn':
      isRequired = !_value || _value.length === 0
      re = /([0-9]{11})$|([0-9A-Za-z]{30})$/
      isValid = !isRequired && re.test(_value)
      if (isValid) {
        const result = re.exec(_value)
        const cro = result[1]
        const trn = result[2]
        if (cro !== undefined) {
          if (cro !== '00000000000') {
            const croDividendo = parseInt(cro.substring(0, 9), 10)
            const croModulo = parseInt(cro.substring(9, 11), 10)
            isValid = croDividendo % 13 === croModulo
          } else {
            isValid = false
          }
        } else if (trn !== undefined) {
          // da fare
        }
        if (isValid) {
          _value = _value.toUpperCase()
        }
      }
      break
    case 'dati_findomestic_seconda_cittadinanza':
      isRequired = false
      isValid = true
      break
    default:
      isValid = false
      break
  }

  return {
    isRequired,
    isValid,
    is_required: isRequired,
    is_valid: isValid,
    value: _value,
    updates,
  }
}

export default verify
